import React, { Component } from 'react';
import { formatVietnameseDate, getTeethStatusLabel, isValidDate } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';

class PrintGeneralExam extends Component {

    render() {
        const { customer, data } = this.props;

        const ly_do_den_kham = data?.ly_do_den_kham || [];
        const ly_do_khac = data?.ly_do_khac || '';
        const mong_muon_khach_hang = data?.mong_muon_khach_hang || '';
        const diseases = data?.diseases || [];
        const tooth_type = data?.tooth_type || '';
        const teeth = data?.teeth || [];
        const tinh_trang_cao_rang = data?.tinh_trang_cao_rang || '';
        const tinh_trang_nuou = data?.tinh_trang_nuou || '';
        const mau_sac_rang = data?.mau_sac_rang || '';
        const tinh_trang_rang_khon = data?.tinh_trang_rang_khon || '';
        const pain_label = data?.pain || '';
        const sound_label = data?.sound || '';
        const zigzag_label = data?.zigzag || '';
        const chan_doan_tren_phim_x_quang = data?.chan_doan_tren_phim_x_quang || '';
        const chan_doan_so_bo = data?.chan_doan_so_bo || '';
        const lay_cao_rang = data?.lay_cao_rang || '';
        const tram_cac_rang = data?.tram_cac_rang || '';
        const dieu_tri_tuy_cac_rang = data?.dieu_tri_tuy_cac_rang || '';
        const trong_cac_rang = data?.trong_cac_rang || '';
        const lam_cau_chup = data?.lam_cau_chup || '';
        const nho_rang = data?.nho_rang || '';
        const dieu_tri_khac = data?.dieu_tri_khac || [];
        const chi_dinh_khac = data?.chi_dinh_khac || '';
        const chi_tiet_chi_dinh = data?.chi_tiet_chi_dinh || '';
        const noi_dung_tu_van = data?.noi_dung_tu_van || '';
        const created_at = data?.created_at || '';
        const doctor = data?.doctor?.full_name || '';

        const addressParts = [
            customer?.address?.trim(),
            customer?.hamlet?.trim(),
            customer?.wards_name?.trim(),
            customer?.province_name?.trim(),
        ];

        // Lọc bỏ phần rỗng hoặc undefined, rồi nối bằng dấu phẩy
        const address = addressParts.filter(Boolean).join(', ') || '-';

        return (
            <div className="container print-content">

                <div className="header">
                    <div className="logo-box">
                        <img src="https://chingodental.vn/Logo-fanpage-2.png" alt="Logo Chingo Dental" />
                    </div>

                    <div className="footer">
                        <div className="qr-box">
                            <img src="https://chingodental.vn/QRCode.jpg" alt="QR Code" />
                        </div>

                        <div className="clinic">
                            <div className="section-title">NHA KHOA CHINGO</div>
                            <span>CS1: Số 560 Nguyễn Văn Cừ, Phường Bồ Đề, TP. Hà Nội</span>
                            <span>Hotline: 0978 009 780</span>
                            <span>CS2: Số 22 Lê Hồng Phong, Phường Hải Châu, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                            <span>CS3: Số 17 Lý Nam Đế, Phường Hội An, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                        </div>
                    </div>
                </div>

                <div className="title-wrap">
                    <h1>PHIẾU KHÁM TỔNG QUÁT RĂNG MIỆNG</h1>
                </div>


                <h2 className="section-title">I. THÔNG TIN KHÁCH HÀNG</h2>
                <table className="kv-table mb-4">
                    <tr>
                        <th>Họ và tên khách hàng</th>
                        <td><strong>{customer?.full_name}</strong></td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{customer?.code}</td>
                    </tr>
                    <tr>
                        <th>Số CCCD/CMND</th>
                        <td>{customer?.identity_number}</td>
                    </tr>
                    <tr>
                        <th>Ngày sinh</th>
                        <td>{isValidDate(customer?.birthday, false)}</td>
                    </tr>
                    <tr>
                        <th>Tuổi</th>
                        <td>{customer?.age}</td>
                    </tr>
                    <tr>
                        <th>Địa chỉ</th>
                        <td>{address}</td>
                    </tr>
                </table>


                <h2 className="section-title">II. LÝ DO ĐẾN KHÁM</h2>
                {ly_do_den_kham && ly_do_den_kham.length > 0 && <div className="mb-2">• {ly_do_den_kham.join(', ')}</div>}
                {ly_do_khac && <div className="mb-2">• <strong>Lý do khác:</strong> {ly_do_khac}</div>}
                {mong_muon_khach_hang && <div className="mt-2 mb-2">• <strong>Mong muốn của khách hàng:</strong> {mong_muon_khach_hang} </div>}

                <h2 className="section-title">III. BỆNH LÝ CẦN LƯU Ý</h2>
                {diseases && Object.keys(diseases).length > 0 && (
                    <div className="mb-2">
                        <strong>Các bệnh lý đã và đang mắc phải:</strong>{" "}
                        {Object.entries(diseases)
                            .filter(([_, value]) => value === "yes") // chỉ lấy những bệnh có "yes"
                            .map(([name]) => name)
                            .join(", ")}
                    </div>
                )}

                <h2 className="section-title">IV. KHÁM TỔNG QUÁT RĂNG MIỆNG</h2>
                <div className="mb-2">• <strong>Loại răng:</strong> {tooth_type === 'children' ? 'Trẻ em' : 'Người trưởng thành'} </div>
                {teeth && teeth.length > 0 && (
                    <div className="mb-2">
                        <strong>• Các răng bị ảnh hưởng:</strong>
                        <ul style={{ marginTop: 8, marginBottom: 0 }}>
                            {teeth
                                .filter((t) => t.status !== "none") // loại bỏ những răng bình thường
                                .map((t) => {
                                    const note = t.note?.trim();
                                    return (
                                        <li className="mb-2 line-height-20" key={t.id}>
                                            <span>
                                                <strong>{getTeethStatusLabel(t.status)}</strong>
                                            </span>{" "}
                                            răng số <strong>{t.tooth_number}</strong>
                                            {note ? (
                                                <>
                                                    {" "}- Ghi chú: <i>{HtmlParser(note)}</i>
                                                </>
                                            ) : null}
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                )}


                {tinh_trang_cao_rang && <div className="mb-2">• <strong>Tình trạng cao răng:</strong> {tinh_trang_cao_rang}</div>}
                {tinh_trang_nuou && <div className="mb-2">• <strong>Tình trạng nướu (lợi):</strong> {tinh_trang_nuou} </div>}
                {mau_sac_rang && <div className="mb-2">• <strong>Màu sắc răng:</strong> {mau_sac_rang}</div>}
                {tinh_trang_rang_khon && <div className="mb-2">• <strong>Tình trạng răng khôn:</strong> {tinh_trang_rang_khon} </div>}

                <div className="section-subtitle"><strong>• Tình trạng khớp cắn:</strong></div>
                <div className="bite-status mt-2 mb-2 pl-4">
                    <div className="bite-status mt-2 mb-2 pl-4">
                        {pain_label === 'yes' && (
                            <div className="bite-item">
                                <span className="bite-label">Khớp thái dương có triệu chứng đau</span>
                            </div>
                        )}

                        {sound_label === 'yes' && (
                            <div className="bite-item">
                                <span className="bite-label">Phát tiếng kêu khi há/đóng miệng tối đa</span>
                            </div>
                        )}

                        {zigzag_label === 'yes' && (
                            <div className="bite-item">
                                <span className="bite-label">Đường há ngậm miệng dạng zích-zắc</span>
                            </div>
                        )}
                    </div>

                </div>

                {chan_doan_tren_phim_x_quang && (
                    <>
                        <h2 className="section-title">V. CHẨN ĐOÁN TRÊN PHIM X-QUANG</h2>
                        <div className="mb-2">{chan_doan_tren_phim_x_quang}</div>
                    </>
                )}
                {chan_doan_so_bo && (<>
                    <h2 className="section-title">VI. CHẨN ĐOÁN SƠ BỘ</h2>
                    <div className="mb-2">{chan_doan_so_bo}</div>
                </>)}

                <h2 className="section-title">VII. HƯỚNG ĐIỀU TRỊ</h2>
                {lay_cao_rang && <div className="mb-2">• <strong>Lấy cao răng, điều trị viêm lợi:</strong> {lay_cao_rang}</div>}
                {tram_cac_rang && <div className="mb-2">• <strong>Trám các răng:</strong> {tram_cac_rang}</div>}
                {dieu_tri_tuy_cac_rang && <div className="mb-2">• <strong>Điều trị tủy các răng:</strong> {dieu_tri_tuy_cac_rang}</div>}
                {trong_cac_rang && <div className="mb-2">• <strong>Trồng các răng:</strong> {trong_cac_rang}</div>}
                {lam_cau_chup && <div className="mb-2">• <strong>Làm cầu, chụp:</strong> {lam_cau_chup}</div>}
                {nho_rang && <div className="mb-2">• <strong>Nhổ răng:</strong> {nho_rang}</div>}
                {dieu_tri_khac && dieu_tri_khac.length > 0 && <div className="mb-2">• <strong>Chăm sóc & điều trị khác:</strong> {dieu_tri_khac.join(", ")}</div>}
                {chi_dinh_khac && <div className="mb-2">• <strong>Chỉ định khác:</strong> {chi_dinh_khac}</div>}
                {chi_tiet_chi_dinh && <div className="mb-2">• <strong>Chi tiết chỉ định:</strong> {chi_tiet_chi_dinh}</div>}

                {/* {noi_dung_tu_van && (<>
                    <h2 className="section-title">VIII. NỘI DUNG TƯ VẤN <span className="subtitle">(dành cho nhân viên tư vấn)</span></h2>
                    <div className="mb-2"> {noi_dung_tu_van}</div>
                </>)} */}


                <div className="print-date">
                    .............., ngày {formatVietnameseDate(created_at)}
                </div>


                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{doctor}</div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>

                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                            margin: 1.8cm 1.5cm 2cm 1.8cm; /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                        }

                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0;
                            position: relative;
                        }

                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 13.5pt;
                            /* border-left: 4px solid var(--primary);
                            padding-left: 8px; */
                            margin: 18px 0 10px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                         /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 32%;
                            /* background: #fafafa; */
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .checkbox {
                            font-family: "Segoe UI Symbol", "DejaVu Sans", "Times New Roman";
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12.5pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintGeneralExam;
